import React from "react";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="conatiner text-center top">
          <p>© 2022. All rights reserved by imneerajkumar.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
